module.exports = __webpack_public_path__ + "img/c99cbc1.png";